import {
    Button,
    ButtonBase,
    Checkbox,
    Chip,
    ClickAwayListener,
    Divider,
    Fade,
    FormControlLabel,
    Grid,
    Paper,
    Popper,
    Radio,
    Switch,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { each, get, set } from "lodash";
import { useEffect, useRef, useState } from "react";
import Scroll from "react-scroll";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { DownChevron } from "../../../common/js/icons";
import LocationFilters from "../property/LocationFilters";
import MarketFilters from "../property/MarketFilters";
import PropertyTypeFilter from "../property/PropertyTypeFilter";
import searchConstants from "../search/constants";

const StyledMenuSearchButton = styled(Button)({
    marginBottom: "15px",
});

const StyledPropertyTypeContainer = styled(Paper)({
    width: "32em",
});

const StyledMarketFilterContainer = styled(Paper)({
    width: "32em",
});

const StyledStatusContainer = styled(Paper)({
    minWidth: "210px",
    padding: "0 15px",
});

const StyledLabelThing = styled(FormControlLabel)({
    marginRight: "0",
});

const StyledFakeSelect = styled(ButtonBase)({
    height: "39px",
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
    marginLeft: 0,
    fontWeight: 400,
    width: "100%",
    justifyContent: "flex-start",
    padding: "0 26px 0 6px",
    backgroundColor: "white",
    fontSize: "14px",
    "&.Mui-focusVisible": {
        border: "1px solid #2C99D2",
        backgroundColor: "white",
    },
});

const StyledFakeSelectIcon = styled("span")({
    position: "absolute",
    right: "6px",
    fontSize: "16px",
});

const StyledFilterBar = styled("div")({
    backgroundColor: "white",
    paddingTop: "15px",
    paddingRight: "20px",
    paddingLeft: "15px",
    borderBottom: "1px solid #eee",
});

const StyledStatusSwitch = styled(Switch)({
    marginRight: "-15px",
});

const StyledMenuTitle = styled("span")({
    fontSize: "14px",
});

const StyledHrDivider = styled(Divider)({
    position: "absolute",
    width: "100%",
    left: 0,
    top: "35px",
});

const StyledLocationFilterContainer = styled(Paper)({
    minWidth: "350px",
    padding: "20px",
});

const StyledDealTypeFilterContainer = styled(Paper)({
    padding: "20px",
});

const StyledMenuSectionTitle = styled("h4")({
    color: "#9E9E9E",
    fontSize: "13px",
    fontWeight: 600,
    textTransform: "uppercase",
    marginBottom: "5px",
});

const StyledOfficeDropdown = styled(Grid)({
    marginTop: 0,
    height: "30px",
});

const StyledFilterContainer = styled("div")({
    justifyContent: "space-between",
    alignItems: "center",
    margin: "-4px",
    display: "flex",
    flexWrap: "wrap",
    boxSizing: "border-box",
});

const StyledDealTypeItem = styled("div")({
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    boxSizing: "border-box",
    width: "100%",
});

const StyledFilterItem = styled("div")({
    flexGrow: 1,
    maxWidth: "100%",
    flexBasis: 0,
    boxSizing: "border-box",
    padding: "4px",
});

const StyledHalfWidth = styled("div")({
    boxSizing: "border-box",
    padding: "4px",
    flexGrow: "0",
    maxWidth: "50%",
    flexBasis: "50%",
});

const CompFilters = (props) => {
    const {
        loadedSearchCrumbs,
        searchSubmit,
        clearFilters,
        handleSearchCleared,
        handleSizeRadioClick,
        handleSearchRunStatus,
        searchCriteria,
        handleSelectAllPropertyType,
        updateFilter,
        propertySearchFilters,
        togglePropertyTypeExpansionPanel,
        propertyTypeExpansionPanels,
        toggleMarketFilterExpansionPanel,
        marketFilterExpansionPanels,
        handleSelectMarket,
        handleSelectSubmarket,
        handleSelectMicromarket,
        handleDeleteCrumb,
    } = props;

    const clickedOnDropdownToggleRef = useRef(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [placement, setPlacement] = useState(null);

    const initializeSizeCriteria = () => {
        if (
            !get(searchCriteria, "sizeCriteria.totalTransactionSf", false) &&
            !get(searchCriteria, "sizeCriteria.totalSf", false) &&
            !get(searchCriteria, "sizeCriteria.acreage", false)
        ) {
            handleSizeRadioClick("totalTransactionSf", true);
        }
    };

    useEffect(() => {
        initializeSizeCriteria();
    });

    let Element = Scroll.Element;

    const onKeyPress = (event) => {
        if (event.key === "Enter") {
            clickedOnDropdownToggleRef.current = false;
            searchSubmit();
            handleClose();
        }
    };

    const handleSearchSubmit = () => {
        clickedOnDropdownToggleRef.current = false;
        handleSearchRunStatus();
        handleSearchCleared(false);
        searchSubmit();
        handleClose();
    };

    const handleClick = (placementArg) => (event, filter) => {
        clickedOnDropdownToggleRef.current = true;
        const { currentTarget } = event;
        if (openDropdown === filter && placement === placementArg) {
            // Toggle off the same dropdown
            setOpenDropdown(null);
            setAnchorEl(null);
        } else {
            // Open new dropdown
            setOpenDropdown(filter);
            setAnchorEl(currentTarget);
            setPlacement(placementArg);
        }
    };

    const handleClose = () => {
        if (clickedOnDropdownToggleRef.current) {
            clickedOnDropdownToggleRef.current = false; // Reset it
            return; // Skip closing — click was on dropdown toggle
        }
        setOpenDropdown(null);
    };

    const countFilter = (searchCriteria, filterName) => {
        let count = 0;
        each(get(searchCriteria, filterName, []), (option) => {
            if (option === true) {
                count += 1;
            }
        });
        return count;
    };

    const countPropertyTypeSelected = (searchCriteria) => {
        let count = 0;
        each(get(searchCriteria, "propertyTypes", []), (p) => {
            if (p.selected === true) {
                count += 1;
            }
        });
        return count;
    };

    const checkForLeaseOnly = (checked, box) => {
        let currentState = {
            excludeSubleases: get(searchCriteria, "dealTypeCriteria.excludeSubleases"),
            sublease: get(searchCriteria, "dealTypeCriteria.sublease"),
            investmentSaleFlg: get(searchCriteria, "dealTypeCriteria.investmentSaleFlg"),
            sale: get(searchCriteria, "dealTypeCriteria.sale"),
            appraisalCompsOnly: get(searchCriteria, "dealTypeCriteria.appraisalCompsOnly"),
            kmCompsOnly: get(searchCriteria, "dealTypeCriteria.kmCompsOnly"),
            outsideCompsOnly: get(searchCriteria, "dealTypeCriteria.outsideCompsOnly"),
            outsidePartialCompsOnly: searchCriteria?.dealTypeCriteria?.outsidePartialCompsOnly,
            lease: get(searchCriteria, "dealTypeCriteria.lease"),
        };
        set(currentState, box, checked);
        console.log(currentState);
        if (
            !get(currentState, "sublease") &&
            !get(currentState, "excludeSubleases") &&
            !get(currentState, "investmentSaleFlg") &&
            !get(currentState, "sale") &&
            !get(currentState, "appraisalCompsOnly") &&
            !get(currentState, "kmCompsOnly") &&
            !get(currentState, "outsideCompsOnly") &&
            !currentState?.dealTypeCriteria?.outsidePartialCompsOnly &&
            get(currentState, "lease")
        ) {
            console.log("lease only");
            handleSelectAllPropertyType("Hospitality", false);
        }
        updateFilter(`dealTypeCriteria.${box}`, checked);
    };

    const combineFilterCount = (searchCriteria, criteriaOne, criteriaTwo) => {
        return countFilter(searchCriteria, criteriaOne) + countFilter(searchCriteria, criteriaTwo);
    };

    const handleClearFilters = () => {
        clearFilters();
        handleSearchCleared(true);
        handleClose();
        handleSizeRadioClick("totalTransactionSf", true);
    };

    return (
        <StyledFilterBar>
            <StyledFilterContainer>
                <div style={{ fontWeight: 400, maxWidth: "70px", marginLeft: "12px", marginRight: "5px" }}>
                    <div>Filters:</div>
                </div>
                <StyledFilterItem>
                    <Popper open={openDropdown === "location"} anchorEl={anchorEl} placement={placement} transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={100}>
                                <div>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <StyledLocationFilterContainer>
                                            <LocationFilters
                                                updateFilter={updateFilter}
                                                searchCriteria={searchCriteria}
                                                onKeyPress={onKeyPress}
                                                hideFilters={true}
                                            ></LocationFilters>
                                            <Grid
                                                container
                                                spacing={16}
                                                sx={{
                                                    justifyContent: "flex-end",
                                                }}
                                            >
                                                <Grid>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleSearchSubmit}
                                                    >
                                                        Search
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </StyledLocationFilterContainer>
                                    </ClickAwayListener>
                                </div>
                            </Fade>
                        )}
                    </Popper>
                    <StyledFakeSelect onClick={(e) => handleClick("bottom-start")(e, "location")}>
                        {"Location"}
                        <StyledFakeSelectIcon>
                            <DownChevron />
                        </StyledFakeSelectIcon>
                    </StyledFakeSelect>
                </StyledFilterItem>
                <StyledFilterItem>
                    <Popper open={openDropdown === "marketArea"} anchorEl={anchorEl} placement={placement} transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={100}>
                                <div>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <StyledMarketFilterContainer>
                                            <Element style={{ height: "400px", overflowY: "scroll" }}>
                                                <MarketFilters
                                                    searchCriteria={searchCriteria}
                                                    toggleMarketFilterExpansionPanel={toggleMarketFilterExpansionPanel}
                                                    marketFilterExpansionPanels={marketFilterExpansionPanels}
                                                    handleSelectMarket={handleSelectMarket}
                                                    handleSelectSubmarket={handleSelectSubmarket}
                                                    handleSelectMicromarket={handleSelectMicromarket}
                                                ></MarketFilters>
                                            </Element>
                                            <Grid
                                                container
                                                spacing={16}
                                                style={{ padding: "10px", paddingRight: "16px" }}
                                                sx={{
                                                    justifyContent: "flex-end",
                                                }}
                                            >
                                                <Grid>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleSearchSubmit}
                                                    >
                                                        Search
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </StyledMarketFilterContainer>
                                    </ClickAwayListener>
                                </div>
                            </Fade>
                        )}
                    </Popper>
                    <StyledFakeSelect onClick={(e) => handleClick("bottom-start")(e, "marketArea")}>
                        {`Market Area ${
                            countFilter(searchCriteria, "locationCriteria.markets") > 0
                                ? `(${countFilter(searchCriteria, "locationCriteria.markets")})`
                                : ""
                        }`}
                        <StyledFakeSelectIcon>
                            <DownChevron />
                        </StyledFakeSelectIcon>
                    </StyledFakeSelect>
                </StyledFilterItem>
                <StyledFilterItem>
                    <Popper open={openDropdown === "propertyType"} anchorEl={anchorEl} placement={placement} transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={100}>
                                <div>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <StyledPropertyTypeContainer>
                                            <PropertyTypeFilter
                                                updateFilter={updateFilter}
                                                propertySearchFilters={propertySearchFilters}
                                                handleSelectAllPropertyType={handleSelectAllPropertyType}
                                                searchCriteria={searchCriteria}
                                                handleSearchSubmit={handleSearchSubmit}
                                                togglePropertyTypeExpansionPanel={togglePropertyTypeExpansionPanel}
                                                propertyTypeExpansionPanels={propertyTypeExpansionPanels}
                                            />
                                        </StyledPropertyTypeContainer>
                                    </ClickAwayListener>
                                </div>
                            </Fade>
                        )}
                    </Popper>
                    <StyledFakeSelect onClick={(e) => handleClick("bottom-start")(e, "propertyType")}>
                        {`Space Use ${
                            countPropertyTypeSelected(searchCriteria) > 0
                                ? `(${countPropertyTypeSelected(searchCriteria)})`
                                : ""
                        }`}
                        <StyledFakeSelectIcon>
                            <DownChevron />
                        </StyledFakeSelectIcon>
                    </StyledFakeSelect>
                </StyledFilterItem>
                <StyledFilterItem>
                    <Popper open={openDropdown === "dealType"} anchorEl={anchorEl} placement={placement} transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={100}>
                                <div>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <StyledDealTypeFilterContainer>
                                            <Element style={{ height: "400px", overflowY: "scroll" }}>
                                                <div
                                                    style={{
                                                        margin: 0,
                                                        width: "95%",
                                                        diplay: "flex",
                                                        flexWrap: "wrap",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    <div>
                                                        <div>
                                                            <StyledDealTypeItem>
                                                                <StyledMenuTitle>Validated Comps Only</StyledMenuTitle>
                                                                <StyledStatusSwitch
                                                                    checked={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.validatedCompsOnly",
                                                                        false
                                                                    )}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.validatedCompsOnly",
                                                                            e.target.checked
                                                                        )
                                                                    }
                                                                    value="validatedCompsOnly"
                                                                    color="primary"
                                                                />
                                                            </StyledDealTypeItem>
                                                        </div>
                                                        {/*below is copy of km comps only toggle but will be include CONFIDENTIAL comps*/}
                                                        <div>
                                                            <StyledDealTypeItem>
                                                                <StyledMenuTitle>
                                                                    Include Confidential Comps
                                                                </StyledMenuTitle>
                                                                <StyledStatusSwitch
                                                                    checked={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.confidentialComps",
                                                                        false
                                                                    )}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.confidentialComps",
                                                                            e.target.checked
                                                                        )
                                                                    }
                                                                    value="confidentialComps"
                                                                    color="primary"
                                                                />
                                                            </StyledDealTypeItem>
                                                        </div>

                                                        <Divider style={{ margin: "10px -20px 12px -20px" }} />

                                                        <StyledDealTypeItem style={{ margin: "-4px" }}>
                                                            <StyledHalfWidth>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.lease",
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                checkForLeaseOnly(
                                                                                    e.target.checked,
                                                                                    "lease"
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="Lease"
                                                                />
                                                            </StyledHalfWidth>
                                                            <StyledHalfWidth>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.sale",
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                checkForLeaseOnly(
                                                                                    e.target.checked,
                                                                                    "sale"
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="Sale"
                                                                />
                                                            </StyledHalfWidth>
                                                        </StyledDealTypeItem>

                                                        <Divider style={{ margin: "10px -20px 12px -20px" }} />

                                                        <StyledDealTypeItem style={{ margin: "-4px" }}>
                                                            <StyledHalfWidth>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.kmCompsOnly",
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                checkForLeaseOnly(
                                                                                    e.target.checked,
                                                                                    "kmCompsOnly"
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="KM Comps Only"
                                                                />
                                                            </StyledHalfWidth>
                                                            <StyledHalfWidth>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.appraisalCompsOnly",
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                checkForLeaseOnly(
                                                                                    e.target.checked,
                                                                                    "appraisalCompsOnly"
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="Appraisal Comps"
                                                                />
                                                            </StyledHalfWidth>
                                                            <StyledHalfWidth>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.outsideCompsOnly",
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                checkForLeaseOnly(
                                                                                    e.target.checked,
                                                                                    "outsideCompsOnly"
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="Outside Comps (Complete)"
                                                                />
                                                            </StyledHalfWidth>
                                                            <StyledHalfWidth>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.outsidePartialCompsOnly",
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                checkForLeaseOnly(
                                                                                    e.target.checked,
                                                                                    "outsidePartialCompsOnly"
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="Outside Comps (Partial)"
                                                                />
                                                            </StyledHalfWidth>
                                                        </StyledDealTypeItem>

                                                        <Divider style={{ margin: "10px -20px 12px -20px" }} />

                                                        <StyledDealTypeItem style={{ margin: "-4px" }}>
                                                            <StyledHalfWidth>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            disabled={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.excludeSubleases",
                                                                                false
                                                                            )}
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.sublease",
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                checkForLeaseOnly(
                                                                                    e.target.checked,
                                                                                    "sublease"
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="Sublease Only"
                                                                />
                                                            </StyledHalfWidth>
                                                            <StyledHalfWidth>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            disabled={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.sublease",
                                                                                false
                                                                            )}
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.excludeSubleases",
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                checkForLeaseOnly(
                                                                                    e.target.checked,
                                                                                    "excludeSubleases"
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="Exclude Subleases"
                                                                />
                                                            </StyledHalfWidth>
                                                            <StyledHalfWidth>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                "dealTypeCriteria.investmentSaleFlg",
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                checkForLeaseOnly(
                                                                                    e.target.checked,
                                                                                    "investmentSaleFlg"
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label="Investment Only"
                                                                />
                                                            </StyledHalfWidth>
                                                        </StyledDealTypeItem>

                                                        <Divider style={{ margin: "10px -20px 18px -20px" }} />

                                                        <StyledDealTypeItem style={{ height: "86px" }}>
                                                            <div
                                                                style={{
                                                                    flexGrow: 0,
                                                                    maxWidth: "33.33333%",
                                                                    flexBasis: "33.33333%",
                                                                    boxSizing: "border-box",
                                                                }}
                                                            >
                                                                <BSInput
                                                                    id="minLeaseRate"
                                                                    label="Lease Rate"
                                                                    placeholder="Min Lease Rate"
                                                                    value={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.minLeaseRate",
                                                                        ""
                                                                    )}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.minLeaseRate",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    onKeyPress={onKeyPress}
                                                                    numeric
                                                                />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    boxSizing: "border-box",
                                                                    color: "grey",
                                                                }}
                                                            >
                                                                &mdash;
                                                            </div>
                                                            <div
                                                                style={{
                                                                    flexGrow: 0,
                                                                    maxWidth: "33.33333%",
                                                                    flexBasis: "33.33333%",
                                                                    boxSizing: "border-box",
                                                                }}
                                                            >
                                                                <BSInput
                                                                    id="maxLeaseRate"
                                                                    placeholder="Max Lease Rate"
                                                                    value={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.maxLeaseRate",
                                                                        ""
                                                                    )}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.maxLeaseRate",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    onKeyPress={onKeyPress}
                                                                    numeric
                                                                />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    flexGrow: 0,
                                                                    maxWidth: "25%",
                                                                    flexBasis: "25%",
                                                                    boxSizing: "border-box",
                                                                }}
                                                            >
                                                                <BSSelect
                                                                    id="leaseRateType"
                                                                    value={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.leaseRateType",
                                                                        ""
                                                                    )}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.leaseRateType",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    placeholder="Select"
                                                                    options={[
                                                                        {
                                                                            value: "$/SF/Month",
                                                                            label: "$/SF/Month",
                                                                        },
                                                                        {
                                                                            value: "$/SF/Year",
                                                                            label: "$/SF/Year",
                                                                        },
                                                                    ]}
                                                                    disabled={false}
                                                                />
                                                            </div>
                                                        </StyledDealTypeItem>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                flexWrap: "wrap",
                                                                boxSizing: "border-box",
                                                                alignItems: "center",
                                                                height: "94px",
                                                                margin: "-8px",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    flexGrow: 1,
                                                                    maxWidth: "100%",
                                                                    flexBasis: 0,
                                                                    boxSizing: "border-box",
                                                                }}
                                                            >
                                                                <BSInput
                                                                    label="Sale Price"
                                                                    placeholder="Min Sale price"
                                                                    value={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.minPrice",
                                                                        ""
                                                                    )}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.minPrice",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    onKeyPress={onKeyPress}
                                                                    numeric
                                                                />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    boxSizing: "border-box",
                                                                    color: "grey",
                                                                }}
                                                            >
                                                                &mdash;
                                                            </div>
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    flexGrow: 1,
                                                                    maxWidth: "100%",
                                                                    flexBasis: 0,
                                                                    boxSizing: "border-box",
                                                                }}
                                                            >
                                                                <BSInput
                                                                    placeholder="Max Sale price"
                                                                    value={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.maxPrice",
                                                                        ""
                                                                    )}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.maxPrice",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    onKeyPress={onKeyPress}
                                                                    numeric
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                flexWrap: "wrap",
                                                                boxSizing: "border-box",
                                                                alignItems: "center",
                                                                height: "94px",
                                                                margin: "-8px",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    flexGrow: 1,
                                                                    maxWidth: "100%",
                                                                    flexBasis: 0,
                                                                    boxSizing: "border-box",
                                                                }}
                                                            >
                                                                <BSInput
                                                                    label="Date Signed"
                                                                    placeholder="Date Signed (From)"
                                                                    value={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.transactionDateFrom",
                                                                        ""
                                                                    )}
                                                                    type={"date"}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.transactionDateFrom",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    boxSizing: "border-box",
                                                                    color: "grey",
                                                                }}
                                                            >
                                                                &mdash;
                                                            </div>
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    flexGrow: 1,
                                                                    maxWidth: "100%",
                                                                    flexBasis: 0,
                                                                    boxSizing: "border-box",
                                                                }}
                                                            >
                                                                <BSInput
                                                                    placeholder="Date Signed (To)"
                                                                    value={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.transactionDateTo",
                                                                        ""
                                                                    )}
                                                                    type={"date"}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.transactionDateTo",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                flexWrap: "wrap",
                                                                boxSizing: "border-box",
                                                                alignItems: "center",
                                                                height: "94px",
                                                                margin: "-8px",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    flexGrow: 1,
                                                                    maxWidth: "100%",
                                                                    flexBasis: 0,
                                                                    boxSizing: "border-box",
                                                                }}
                                                            >
                                                                <BSInput
                                                                    label="Transaction Date"
                                                                    placeholder="Transaction Date (From)"
                                                                    value={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.batchDateFrom",
                                                                        ""
                                                                    )}
                                                                    type={"date"}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.batchDateFrom",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    boxSizing: "border-box",
                                                                    color: "grey",
                                                                }}
                                                            >
                                                                &mdash;
                                                            </div>
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    flexGrow: 1,
                                                                    maxWidth: "100%",
                                                                    flexBasis: 0,
                                                                    boxSizing: "border-box",
                                                                }}
                                                            >
                                                                <BSInput
                                                                    placeholder="Transaction Date (To)"
                                                                    value={get(
                                                                        searchCriteria,
                                                                        "dealTypeCriteria.batchDateTo",
                                                                        ""
                                                                    )}
                                                                    type={"date"}
                                                                    onChange={(e) =>
                                                                        updateFilter(
                                                                            "dealTypeCriteria.batchDateTo",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                justifyContent: "flex-end",
                                                                display: "flex",
                                                                flexWrap: "wrap",
                                                                boxSizing: "border-box",
                                                            }}
                                                        >
                                                            <div style={{ boxSizing: "border-box" }}>
                                                                <StyledMenuSearchButton
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handleSearchSubmit}
                                                                >
                                                                    Search
                                                                </StyledMenuSearchButton>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Element>
                                        </StyledDealTypeFilterContainer>
                                    </ClickAwayListener>
                                </div>
                            </Fade>
                        )}
                    </Popper>
                    <StyledFakeSelect onClick={(e) => handleClick("bottom-start")(e, "dealType")}>
                        {`Deal Type ${
                            countFilter(searchCriteria, "dealTypeCriteria") > 0
                                ? `(${countFilter(searchCriteria, "dealTypeCriteria")})`
                                : ""
                        }`}
                        <StyledFakeSelectIcon>
                            <DownChevron />
                        </StyledFakeSelectIcon>
                    </StyledFakeSelect>
                </StyledFilterItem>
                <StyledFilterItem>
                    <Popper open={openDropdown === "status"} anchorEl={anchorEl} placement={placement} transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={100}>
                                <div>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <StyledStatusContainer>
                                            <div
                                                style={{
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    width: "100%",
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div style={{ boxSizing: "border-box" }}>
                                                    <StyledMenuTitle>KM Managed Only</StyledMenuTitle>
                                                </div>
                                                <div style={{ boxSizing: "border-box" }}>
                                                    <StyledStatusSwitch
                                                        checked={get(
                                                            searchCriteria,
                                                            "statusCriteria.kmManagedOnly",
                                                            false
                                                        )}
                                                        onChange={(e) =>
                                                            updateFilter(
                                                                "statusCriteria.kmManagedOnly",
                                                                e.target.checked
                                                            )
                                                        }
                                                        value="kmManagedOnly"
                                                        color="primary"
                                                    />
                                                </div>
                                                <StyledHrDivider />
                                            </div>
                                            <div style={{ maxWidth: "100%", boxSizing: "border-box" }}>
                                                <StyledMenuSectionTitle>Status </StyledMenuSectionTitle>
                                            </div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        maxWidth: "50%",
                                                        flexBasis: "50%",
                                                        flexGrow: "0",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="existing"
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "statusCriteria.existing",
                                                                    false
                                                                )}
                                                                onClick={(e) =>
                                                                    updateFilter(
                                                                        "statusCriteria.existing",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Existing"
                                                        labelPlacement="end"
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        maxWidth: "50%",
                                                        flexBasis: "50%",
                                                        flexGrow: "0",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="proposed"
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "statusCriteria.proposed",
                                                                    false
                                                                )}
                                                                onClick={(e) =>
                                                                    updateFilter(
                                                                        "statusCriteria.proposed",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Proposed"
                                                        labelPlacement="end"
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        maxWidth: "50%",
                                                        flexBasis: "50%",
                                                        flexGrow: "0",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="underConstruction"
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "statusCriteria.underConstruction",
                                                                    false
                                                                )}
                                                                onClick={(e) =>
                                                                    updateFilter(
                                                                        "statusCriteria.underConstruction",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Under Construction"
                                                        labelPlacement="end"
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        maxWidth: "50%",
                                                        flexBasis: "50%",
                                                        flexGrow: "0",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="underRenovation"
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "statusCriteria.underRenovation",
                                                                    false
                                                                )}
                                                                onClick={(e) =>
                                                                    updateFilter(
                                                                        "statusCriteria.underRenovation",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Under Renovation"
                                                        labelPlacement="end"
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        maxWidth: "50%",
                                                        flexBasis: "50%",
                                                        flexGrow: "0",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="demolished"
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "statusCriteria.demolished",
                                                                    false
                                                                )}
                                                                onClick={(e) =>
                                                                    updateFilter(
                                                                        "statusCriteria.demolished",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Demolished"
                                                        labelPlacement="end"
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        maxWidth: "50%",
                                                        flexBasis: "50%",
                                                        flexGrow: "0",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="land"
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "statusCriteria.land",
                                                                    false
                                                                )}
                                                                onClick={(e) =>
                                                                    updateFilter(
                                                                        "statusCriteria.land",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Land"
                                                        labelPlacement="end"
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        maxWidth: "100%",
                                                        flexGrow: "0",
                                                        flexBasis: "100%",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    <StyledMenuSectionTitle>Tenancy </StyledMenuSectionTitle>
                                                </div>
                                                <div style={{ boxSizing: "border-box" }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "tenancyCriteria.single",
                                                                    false
                                                                )}
                                                                onChange={(e) =>
                                                                    updateFilter(
                                                                        "tenancyCriteria.single",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Single"
                                                    />
                                                </div>
                                                <div style={{ boxSizing: "border-box" }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "tenancyCriteria.multi",
                                                                    false
                                                                )}
                                                                onChange={(e) =>
                                                                    updateFilter(
                                                                        "tenancyCriteria.multi",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Multi"
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    justifyContent: "flex-end",
                                                    width: "100%",
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div style={{ boxSizing: "border-box" }}>
                                                    <StyledMenuSearchButton
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleSearchSubmit}
                                                    >
                                                        Search
                                                    </StyledMenuSearchButton>
                                                </div>
                                            </div>
                                        </StyledStatusContainer>
                                    </ClickAwayListener>
                                </div>
                            </Fade>
                        )}
                    </Popper>
                    <StyledFakeSelect onClick={(e) => handleClick("bottom-start")(e, "status")}>
                        {`Status ${
                            combineFilterCount(searchCriteria, "statusCriteria", "tenancyCriteria") > 0
                                ? `(${combineFilterCount(searchCriteria, "statusCriteria", "tenancyCriteria")})`
                                : ""
                        }`}
                        <StyledFakeSelectIcon>
                            <DownChevron />
                        </StyledFakeSelectIcon>
                    </StyledFakeSelect>
                </StyledFilterItem>
                <StyledFilterItem>
                    <Popper open={openDropdown === "size"} anchorEl={anchorEl} placement={placement} transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={100}>
                                <div>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <StyledStatusContainer>
                                            <div
                                                style={{
                                                    justifyContent: "space-around",
                                                    alignItems: "center",
                                                    width: "100%",
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    boxSizing: "borderBox",
                                                }}
                                            >
                                                <div style={{ boxSizing: "borderBox" }}>
                                                    <StyledLabelThing
                                                        value="totalTransactionSf"
                                                        control={
                                                            <Radio
                                                                color="primary"
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "sizeCriteria.totalTransactionSf",
                                                                    true
                                                                )}
                                                                onClick={(e) =>
                                                                    handleSizeRadioClick(
                                                                        "totalTransactionSf",
                                                                        !get(
                                                                            searchCriteria,
                                                                            "sizeCriteria.totalTransactionSf",
                                                                            false
                                                                        )
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Leased/Sold SF&nbsp;"
                                                    />
                                                </div>
                                                <div style={{ boxSizing: "borderBox" }}>
                                                    <FormControlLabel
                                                        value="totalSf"
                                                        control={
                                                            <Radio
                                                                color="primary"
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "sizeCriteria.totalSf",
                                                                    false
                                                                )}
                                                                onClick={(e) =>
                                                                    handleSizeRadioClick(
                                                                        "totalSf",
                                                                        !get(
                                                                            searchCriteria,
                                                                            "sizeCriteria.totalSf",
                                                                            false
                                                                        )
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Total SF"
                                                    />
                                                </div>
                                                <div style={{ boxSizing: "borderBox" }}>
                                                    <FormControlLabel
                                                        value="acreage"
                                                        control={
                                                            <Radio
                                                                color="primary"
                                                                checked={get(
                                                                    searchCriteria,
                                                                    "sizeCriteria.acreage",
                                                                    false
                                                                )}
                                                                onClick={(e) =>
                                                                    handleSizeRadioClick(
                                                                        "acreage",
                                                                        !get(
                                                                            searchCriteria,
                                                                            "sizeCriteria.acreage",
                                                                            false
                                                                        )
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Total Acreage"
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", alignItems: "center", gap: "1vw" }}>
                                                <BSInput
                                                    placeholder="Min"
                                                    value={get(searchCriteria, "sizeCriteria.min", "")}
                                                    onChange={(e) => updateFilter("sizeCriteria.min", e.target.value)}
                                                    onKeyPress={onKeyPress}
                                                    numeric
                                                />
                                                <div>&mdash;</div>
                                                <BSInput
                                                    placeholder="Max"
                                                    value={get(searchCriteria, "sizeCriteria.max", "")}
                                                    onChange={(e) => updateFilter("sizeCriteria.max", e.target.value)}
                                                    onKeyPress={onKeyPress}
                                                    numeric
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    margin: "-8px",
                                                    justifyContent: "flex-end",
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div style={{ padding: "8px", boxSizing: "border-box" }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleSearchSubmit}
                                                    >
                                                        Search
                                                    </Button>
                                                </div>
                                            </div>
                                        </StyledStatusContainer>
                                    </ClickAwayListener>
                                </div>
                            </Fade>
                        )}
                    </Popper>
                    <StyledFakeSelect onClick={(e) => handleClick("bottom-start")(e, "size")}>
                        Size
                        <StyledFakeSelectIcon>
                            <DownChevron />
                        </StyledFakeSelectIcon>
                    </StyledFakeSelect>
                </StyledFilterItem>
                <StyledFilterItem>
                    <Popper open={openDropdown === "kmOffice"} anchorEl={anchorEl} placement={placement} transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={100}>
                                <div>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <StyledStatusContainer>
                                            <Element style={{ height: "400px", overflowY: "scroll" }}>
                                                <Grid container direction="column">
                                                    {/*for each office*/}
                                                    {Object.keys(searchConstants.kmOffices).map((key, i) => {
                                                        const option = searchConstants.kmOffices[key];
                                                        return (
                                                            <StyledOfficeDropdown item>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={get(
                                                                                searchCriteria,
                                                                                `officeCriteria.${key}`,
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                updateFilter(
                                                                                    "officeCriteria." + key,
                                                                                    e.target.checked
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label={option.display}
                                                                />
                                                            </StyledOfficeDropdown>
                                                        );
                                                    })}
                                                </Grid>
                                            </Element>
                                            <div
                                                style={{
                                                    margin: "-8px",
                                                    justifyContent: "flex-end",
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div style={{ padding: "8px", paddingTop: "30px" }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleSearchSubmit}
                                                    >
                                                        Search
                                                    </Button>
                                                </div>
                                            </div>
                                        </StyledStatusContainer>
                                    </ClickAwayListener>
                                </div>
                            </Fade>
                        )}
                    </Popper>
                    <StyledFakeSelect onClick={(e) => handleClick("bottom-start")(e, "kmOffice")}>
                        {`KM Office ${
                            countFilter(searchCriteria, "officeCriteria") > 0
                                ? `(${countFilter(searchCriteria, "officeCriteria")})`
                                : ""
                        }`}
                        <StyledFakeSelectIcon>
                            <DownChevron />
                        </StyledFakeSelectIcon>
                    </StyledFakeSelect>
                </StyledFilterItem>
                <div style={{ padding: "4px", boxSizing: "border-box" }}>
                    <Button variant="outlined" onClick={handleClearFilters}>
                        Clear
                    </Button>
                </div>
            </StyledFilterContainer>
            <StyledFilterContainer style={{ marginTop: "10px" }}>
                <Grid>
                    {loadedSearchCrumbs
                        ? Object.keys(loadedSearchCrumbs).map((criteria) => {
                              if (loadedSearchCrumbs[criteria].value === true) {
                                  if (Object.keys(loadedSearchCrumbs[criteria]).length === 2) {
                                      return (
                                          <Chip
                                              style={{ marginLeft: "10px", marginBottom: "10px" }}
                                              color="primary"
                                              label={criteria}
                                              onDelete={() => handleDeleteCrumb(loadedSearchCrumbs[criteria], false)}
                                          />
                                      );
                                  } else if (
                                      (loadedSearchCrumbs[criteria].valueMin !== "* " &&
                                          loadedSearchCrumbs[criteria].valueMin !== undefined) ||
                                      (loadedSearchCrumbs[criteria].valueMax !== " *" &&
                                          loadedSearchCrumbs[criteria].valueMax !== undefined)
                                  ) {
                                      return (
                                          <Chip
                                              style={{ marginLeft: "10px", marginBottom: "10px" }}
                                              color="primary"
                                              label={
                                                  criteria +
                                                  get(loadedSearchCrumbs[criteria], "unit", "") +
                                                  ": " +
                                                  get(loadedSearchCrumbs[criteria], "valueMin", "* ") +
                                                  "-" +
                                                  get(loadedSearchCrumbs[criteria], "valueMax", " *")
                                              }
                                              onDelete={() => handleDeleteCrumb(loadedSearchCrumbs[criteria], null)}
                                          />
                                      );
                                  } else {
                                      return null;
                                  }
                              } else if (
                                  typeof loadedSearchCrumbs[criteria].value === "string" &&
                                  loadedSearchCrumbs[criteria].value != null
                              ) {
                                  return (
                                      <Chip
                                          style={{ marginLeft: "10px", marginBottom: "10px" }}
                                          color="primary"
                                          label={criteria + ": " + loadedSearchCrumbs[criteria].value}
                                          onDelete={() => handleDeleteCrumb(loadedSearchCrumbs[criteria], null)}
                                      />
                                  );
                              } else {
                                  return null;
                              }
                          })
                        : ""}
                </Grid>
            </StyledFilterContainer>
        </StyledFilterBar>
    );
};

export default CompFilters;
